<template>
  <div class="home-page">
    <main class="game-stage">
      <section v-if="featuredGames.length || secondaryGroups.length" class="hot-section" aria-label="热门游戏">
        <div class="section-heading">
          <img class="hot-heading-decoration" src="/ui/biaoji_0034.webp" alt="" />
          <h2>热门游戏</h2>
        </div>

        <div class="hot-waterfall">
          <div class="waterfall-column">
            <hot-card
              v-for="card in leftColumnCards"
              :key="card.key"
              :type="card.type"
              :game="card.game"
              :group="card.group"
              @click="onGameClick"
            />
          </div>
          <div class="waterfall-column waterfall-column-right">
            <hot-card
              v-for="card in rightColumnCards"
              :key="card.key"
              :type="card.type"
              :game="card.game"
              :group="card.group"
              @click="onGameClick"
            />
          </div>
        </div>
      </section>

      <div v-if="!loading && !featuredGames.length && !secondaryGroups.length" class="empty-state">
        <span>🎮</span>
        <strong>小游戏正在准备中</strong>
        <p>稍后回来看看吧</p>
      </div>

      <div v-if="loading" class="loading-state">
        <span class="loading-dot"></span>
        <span class="loading-dot"></span>
        <span class="loading-dot"></span>
      </div>
    </main>

  </div>
</template>

<script>
import { loadFullPortalData } from '../store/data'
import { fetchMobilePortalHome } from '../api/portal'
import { trackPageView, trackBoxClick } from '../utils/tracking'
import { launchGameByObject } from '../utils/launchGame'
import HotCard from './home/HotCard.vue'

export default {
  name: 'Home',
  components: { HotCard },
  data() {
    return {
      loading: true,
      featuredGames: [],
      normalMods: [],
      secondaryGames: [],
      gamesById: {},
      viewportWidth: 0
    }
  },
  computed: {
    secondaryGroups() {
      var groups = []
      for (var i = 0; i < this.normalMods.length; i++) {
        var mod = this.normalMods[i]
        var items = (mod.games || []).map(function(game) {
          return this.toDisplayGame(game, null)
        }.bind(this))
        if (items.length > 0) {
          groups.push({ items: items, heading: mod.title || '热门游戏', sort: mod.sort || 0 })
        }
      }
      if (!groups.length) {
        for (var j = 0; j < this.secondaryGames.length; j += 2) {
          groups.push({ items: this.secondaryGames.slice(j, j + 2), heading: '热门游戏', sort: 0 })
        }
      }
      return groups
    },
    hotCards() {
      var cards = []
      var columnWidth = Math.max((this.viewportWidth - 42) / 2, 0)
      this.featuredGames.forEach(function(game, index) {
        cards.push({ key: 'f-' + index + '-' + game.gameId, type: 'featured', game: game, group: null, sort: game.sort || 0, height: Math.max((columnWidth - 6) / 0.78 + 6, 0) })
      })
      this.secondaryGroups.forEach(function(group, index) {
        var itemCount = (group.items || []).length
        cards.push({ key: 'g-' + index, type: 'secondary', game: null, group: group, sort: group.sort || 0, height: 64 + itemCount * 76 })
      })
      // 主推与次推混合排序：sort 从小到大，sort 相同时主推优先
      cards.sort(function(a, b) {
        if (a.sort !== b.sort) return a.sort - b.sort
        return (a.type === 'featured' ? 0 : 1) - (b.type === 'featured' ? 0 : 1)
      })
      return cards
    },
    leftColumnCards() {
      return this.waterfallColumns.left
    },
    rightColumnCards() {
      return this.waterfallColumns.right
    },
    waterfallColumns() {
      var left = []
      var right = []
      var leftHeight = 0
      var rightHeight = 0
      this.hotCards.forEach(function(card) {
        if (leftHeight <= rightHeight) {
          left.push(card)
          leftHeight += card.height
        } else {
          right.push(card)
          rightHeight += card.height
        }
      })
      return { left: left, right: right }
    }
  },
  created() {
    this.loadAllData()
  },
  mounted() {
    this.updateViewportWidth()
    window.addEventListener('resize', this.updateViewportWidth)
    trackPageView(this.$store, 'home')
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportWidth)
  },
  methods: {
    updateViewportWidth() {
      this.viewportWidth = document.documentElement.clientWidth || window.innerWidth || 375
    },
    async loadAllData() {
      await this.$store.getters.waitForReady
      var params = new URLSearchParams(window.location.search)
      var hasJwt = Boolean(params.get('jwt') || params.get('jwt_token'))
      var userId = hasJwt && this.$store.state.userInfo ? this.$store.state.userInfo.userId : null
      try {
        this.applyPortalData(hasJwt ? await loadFullPortalData(userId) : await fetchMobilePortalHome())
      } catch (e) {
        console.error('Portal load failed', e)
      } finally {
        this.loading = false
      }
    },
    applyPortalData(data) {
      var gamesById = data.gamesById || {}
      var banners = data.banners || []
      var allGames = data.games || []
      var featuredMods = data.featuredMods || []
      var normalMods = data.normalMods || []
      var normalModGames = data.normalModGames || []
      var recommendations = data.recommendGames || []
      var featuredBanner = banners.find(function(item) { return item.gameId && gamesById[String(item.gameId)] })
      var featuredSources = featuredMods.map(function(mod) {
        var game = (mod.games && mod.games[0]) || mod.game || null
        return game ? { game: game, banner: { imageUrl: mod.backgroundImage || '' }, sort: mod.sort || 0 } : null
      }).filter(Boolean)
      if (featuredBanner) {
        featuredSources.unshift({
          game: gamesById[String(featuredBanner.gameId)],
          banner: featuredBanner,
          sort: featuredBanner.sortOrder || 0
        })
      }
      if (!featuredSources.length) {
        var fallbackGames = recommendations.length ? recommendations.slice(0, 2) : allGames.slice(0, 2)
        featuredSources = fallbackGames.map(function(game) { return { game: game, banner: null, sort: 0 } })
      }

      this.gamesById = gamesById
      this.normalMods = normalMods
      this.featuredGames = featuredSources.map(function(source) {
        var display = this.toDisplayGame(source.game, source.banner)
        display.sort = source.sort || 0
        return display
      }.bind(this))

      var featuredIds = {}
      this.featuredGames.forEach(function(game) { featuredIds[game.gameId] = true })
      var merged = normalModGames.concat(recommendations, allGames)
      var seen = {}
      this.secondaryGames = merged.reduce(function(result, game) {
        var id = String(game.id)
        if (!id || featuredIds[id] || seen[id]) return result
        seen[id] = true
        result.push(this.toDisplayGame(game, null))
        return result
      }.bind(this), [])
    },
    toDisplayGame(game, banner) {
      var desc = game.gameShortDescription || game.gameDescription || game.desc || game.category || '轻松一点，即刻开玩'
      return {
        gameId: String(game.id),
        name: game.name || (banner && banner.title) || '小游戏',
        icon: game.icon || '🎮',
        heroImage: (banner && banner.imageUrl) || game.cover || '',
        cardImage: game.cover || '',
        shortDesc: desc,
        tagText: '',
        badge: banner ? '' : (game.badge || ''),
        tagColor: game.tagColor || game.backgroundColor || '',
        backgroundColor: game.backgroundColor || ''
      }
    },
    onGameClick(game, source) {
      if (!game || !game.gameId) return
      trackBoxClick(this.$store, game.gameId, source, 'home')
      var full = this.gamesById[String(game.gameId)]
      if (full) {
        launchGameByObject(this.$store, full, source, 'home')
      }
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  min-height: 100dvh;
  color: #1A1A1A;
  background: linear-gradient(180deg, #cfe8ff 0%, #a9d4ff 40%, #6fb3ff 100%);
}

.game-stage {
  position: relative;
  padding: 4px 16px 24px;
}

.section-heading { display: flex; align-items: center; gap: 12px; margin: 4px 0 12px; }
.hot-heading-decoration { display: block; flex: 0 0 7px; width: 7px; height: 28px; object-fit: fill; }
.hot-section .section-heading { padding-left: 4px; }
.section-heading h2 { flex: 1; font-size: 20px; font-weight: 800; letter-spacing: 1.5px; color: #111; }
.heading-more { display: inline-flex; align-items: center; gap: 4px; color: #2F8CFF; font-size: 13px; font-weight: 700; letter-spacing: 0.8px; cursor: pointer; }
.heading-arrow { display: inline-block; font-size: 20px; font-weight: 700; line-height: 0.8; transform: translateY(-1px); }

.hot-waterfall { display: flex; align-items: flex-start; gap: 10px; }
.waterfall-column { display: flex; flex: 1; min-width: 0; flex-direction: column; gap: 10px; }

.empty-state, .loading-state { min-height: 48vh; display: flex; align-items: center; justify-content: center; }
.empty-state { flex-direction: column; color: #8c6546; }
.empty-state span { font-size: 52px; }
.empty-state strong { margin-top: 8px; font-size: 17px; }
.empty-state p { margin-top: 3px; font-size: 12px; }
.loading-state { gap: 7px; }
.loading-dot { width: 9px; height: 9px; border-radius: 50%; background: #2F8CFF; animation: loadingBounce 0.9s ease-in-out infinite alternate; }
.loading-dot:nth-child(2) { animation-delay: 0.15s; }
.loading-dot:nth-child(3) { animation-delay: 0.3s; }
@keyframes loadingBounce { to { transform: translateY(-8px); opacity: 0.45; } }


@media (prefers-reduced-motion: reduce) {
  .loading-dot { animation: none; }
}
</style>
